import React, { PropsWithChildren } from 'react'
import './BaseCarousel.css'
import { cx } from 'class-variance-authority'

interface BaseCarouselProps extends PropsWithChildren {
  LoaderComponent: React.ReactNode
  nbDefaultItems: number
  isLoading: boolean
  containerClassNames?: string
}

export const BaseCarousel = ({
  LoaderComponent,
  children,
  nbDefaultItems = 200,
  isLoading = false,
  containerClassNames = '',
}: BaseCarouselProps) => (
  <section
    className={cx('box-border flex justify-center', containerClassNames)}
  >
    {isLoading ? (
      <div className="box-border flex justify-center">
        <ul
          id="carousel-items"
          className="flex items-center justify-between flex-shrink-0 min-w-full gap-4 select-none"
        >
          {Array.from({ length: nbDefaultItems }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className="w-[273px] h-[340px] list-none" key={i}>
              {LoaderComponent}
            </li>
          ))}
        </ul>
      </div>
    ) : (
      <div
        id="carousel-container"
        className="box-border flex justify-center gap-4 overflow-hidden"
      >
        {Array.from({ length: 2 }).map((_, i) => {
          const firstList = i === 0
          const id = firstList ? 'carousel-items' : 'carousel-items2'

          return (
            <div
              key={i}
              id={id}
              className="flex justify-between flex-shrink-0 min-w-full select-none gap-x-4 md:gap-x-8 lg:gap-x-16"
            >
              {children}
            </div>
          )
        })}
      </div>
    )}
  </section>
)
